(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-info-banner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/play/assets/javascripts/views/andra-chansen/andra-chansen-info-banner.js');

'use strict';

svs.lotto.components.play.views.AndraChansenInfoBanner = Marionette.View.extend({
  modelEvents: {
    'change:hasJoker': 'updateVisibility'
  },
  template() {
    return svs.numbergames.andra_chansen.banners.infoBanner({
      dateSmartness: true,
      className: 'margin-top-2'
    });
  },
  onRender() {
    this.updateVisibility();
  },
  updateVisibility() {
    if (this.model.get('hasJoker')) {
      this.el.style.display = '';
    } else {
      this.el.style.display = 'none';
    }
  }
});

 })(window);